module.exports = __webpack_public_path__ + "img/advantageRed.42cc89c8.jpg";